import { getStoreDefinition } from '@/composables/StoreDefinition'
import { EditorMode } from '@/enums/EditorMode'
import { EndPoint } from '@/enums/EndPoint'
import { FitTestTab } from '@/enums/FitTestTab'
import { SqlComparison } from '@/enums/SqlComparison'
import { SqlOperator } from '@/enums/SqlOperator'
import { SqlOrder } from '@/enums/SqlOrder'
import { TableStoreOptions } from '@/enums/TableStoreOptions'
import type { IFitTestsStore } from '@/interfaces/api/IFitTestsStore'
import { IQueryOptions } from '@/interfaces/api/IQueryOptions'
import type { PeopleRecord } from '@/models/PeopleRecord'
import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useAPIStore } from './ApiStore'

let _store: IFitTestsStore

export const useFitTestsStore = () => {
  if (_store) {
    return _store
  }
  const option = TableStoreOptions.FitTests
  const useStore = defineStore(option.id, getStoreDefinition(option), {
    persist: {
      storage: localStorage,
      pick: ['itemsPerPage']
    }
  })
  _store = useStore() as unknown as IFitTestsStore
  _extend(_store)
  return _store
}

const _extend = (store: IFitTestsStore) => {
  const apiStore = useAPIStore()

  store.selectedTab = ref<FitTestTab>(FitTestTab.Details) as unknown as FitTestTab
  store.defaultEditorMode = EditorMode.View
  store.editorMode = EditorMode.View
  store.itemsPerPage = 5

  store.selectByPersonId = async (personId: number, excludeFailed: boolean = false) => {
    const queryOptions: IQueryOptions = {
      limit: 1,
      where: [
        {
          comparison: SqlComparison.Equal,
          field: 'personId',
          value1: personId
        }
      ],
      orderBy: [{ field: 'testDate', order: SqlOrder.DESC }]
    }

    if (excludeFailed && queryOptions.where) {
      queryOptions.where[0].operator = SqlOperator.And
      queryOptions.where.push({
        comparison: SqlComparison.Equal,
        field: 'overallPass',
        value1: 1
      })
    }

    store.items = []
    const { data, error } = await apiStore.getMany(EndPoint.FitTests, queryOptions)
    if (!error && data && data.count > 0) {
      store.editItem(data?.results[0], false)
    } else {
      store.clearSelectedItem()
    }
  }

  store.setFitTestFilterByPerson = (person: PeopleRecord) => {
    store.items = []
    store.itemQuery = {
      limit: 1,
      offset: 0,
      where: [
        {
          comparison: SqlComparison.Equal,
          field: 'personId',
          value1: person.id
        }
      ],
      orderBy: [{ field: 'testDate', order: SqlOrder.DESC }]
    }
  }
}
